module.exports = __webpack_public_path__ + "static/media/baloons.de513aae.jpg";